import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ClicksIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 36} height={height || 36} viewBox="0 0 36 36">
      <g
        data-name="Ellipse 76"
        transform="translate(0 -.362) translate(0 .362)"
        fill="none"
        stroke={color || "#bbb"}
        strokeWidth={1.5}
      >
        <circle cx={18} cy={18} r={18} stroke="none" />
        <circle cx={18} cy={18} r={17.25} />
      </g>
      <g data-name="Group 785">
        <g data-name="Group 784">
          <path
            data-name="Path 1068"
            d="M9.925 9.18L2.183.109a.309.309 0 00-.436-.034.3.3 0 00-.105.192L.003 12.084a.31.31 0 00.263.349.3.3 0 00.229-.059l3.152-2.4 1.194 4.067a.311.311 0 00.384.21l1.7-.5a.311.311 0 00.21-.384L5.966 9.39l3.7.3A.313.313 0 0010 9.405a.3.3 0 00-.075-.225zm-4.354-.449a.313.313 0 00-.334.285.275.275 0 00.012.111l1.209 4.113-1.107.325-1.234-4.2a.311.311 0 00-.384-.21.271.271 0 00-.1.049L.72 11.422 2.162 1.03l6.809 7.977z"
            fill={color || "#bbb"}
            stroke={color || "#bbb"}
            strokeWidth={0.8}
            transform="translate(0 -.362) translate(13 11.362)"
          />
        </g>
      </g>
    </svg>
  );
}
